import { NO_STOCK_NO_PRICE_PRODUCT } from "theme/config/constants";

interface Parametric {
    type: string;
    parametric: string;
    codes: {
        code: string;
    }[];
    values: {
        value: string;
    }[];
    min: string;
    max: string;
}

interface Pricelist {
    is_manual_code: boolean;
    automatic_pricelist_code: string;
    manual_pricelist_code: string;
    pricelist_contains: boolean;
}

interface Selection {
    categories: string[];
    data: { norce_categories: string[] };
    flags: string[];
    manufacturers: string[];
    parametrics: Parametric[];
    price: {
        min: string;
        max: string;
    };
    pricelists?: Pricelist[];
    group_variants?: boolean;
}

const convertSelectionToFilter = (selection: Selection) => {
    const filters: string[][] = [];

    if (selection?.data?.norce_categories) {
        filters.push(selection.data.norce_categories.map((c) => `categories.code:"${c}"`));
    }
    if (selection.categories) {
        filters.push(selection.categories.map((c) => `categories.code:"${c}"`));
    }

    if (selection.manufacturers) {
        filters.push(selection.manufacturers.map((m) => `manufacturer.code:"${m}"`));
    }

    if (selection.parametrics) {
        selection.parametrics.forEach((p) => {
            switch (p.type) {
                case "codes":
                    return (
                        p.codes &&
                        filters.push(p.codes.map((c) => `parametrics.${p.parametric}.value.code:"${c.code}"`))
                    );
                case "values":
                    return (
                        p.values &&
                        filters.push(p.values.map((v) => `parametrics.${p.parametric}.value.value:"${v.value}"`))
                    );
                case "range":
                    return filters.push([`parametrics.${p.parametric}.value.value: ${p.min} TO ${p.max}`]);
                default:
                    break;
            }
        });
    }

    if (selection.flags) {
        filters.push(selection.flags.map((f) => `flags.code:"${f}"`));
    }

    if (selection.price) {
        const pricingIncVatString = "pricing.pricelists.web.incVat";

        if (selection.price.min && selection.price.max) {
            filters.push([`${pricingIncVatString}: ${selection.price.min} TO ${selection.price.max}`]);
        } else {
            if (selection.price.min) {
                filters.push([`${pricingIncVatString} > ${selection.price.min}`]);
            }

            if (selection.price.max) {
                filters.push([`${pricingIncVatString} < ${selection.price.max}`]);
            }
        }
    }

    if (selection.pricelists?.length) {
        filters.push(
            selection.pricelists
                .map(
                    ({
                        is_manual_code: isManualCode,
                        automatic_pricelist_code: automaticPricelistCode,
                        manual_pricelist_code: manualPricelistCode,
                        pricelist_contains: pricelistContains,
                    }) => {
                        let pricelistFilter = "";
                        if (isManualCode) {
                            if (pricelistContains) {
                                pricelistFilter = manualPricelistCode
                                    ? `pricelist_prefix:"${manualPricelistCode}"`
                                    : "";
                            } else {
                                pricelistFilter = manualPricelistCode ? `pricing.code:"${manualPricelistCode}"` : "";
                            }
                        } else if (automaticPricelistCode) {
                            pricelistFilter = `pricing.code:"${automaticPricelistCode}"`;
                        }

                        return pricelistFilter;
                    },
                )
                .filter((f) => f),
        );
    }

    return filters;
};

export default convertSelectionToFilter;
